import { PATHS } from '@/infrastructure/utils/route-constants';
import authenticated from '@/infrastructure/vue/middleware/authenticated';
import redirectHome from '@/infrastructure/vue/middleware/redirectHome';
import authorized from '@/infrastructure/vue/middleware/authorized';

export default [
  {
    path: '*',
    redirect: {
      path: PATHS.errors.notFound,
    },
  },
  {
    path: '/',
    meta: {},
    name: 'Root',
    redirect: {
      name: 'DashboardPage',
    },
  },

  /* ############################# */
  /*         ERROR PAGES         */
  /* ############################# */

  {
    path: PATHS.errors.notFound,
    name: 'NotFoundPage',
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        /* webpackMode: "lazy-once" */
        `@/infrastructure/vue/pages/errors/NotFoundPage.vue`
      ),
  },
  {
    path: PATHS.errors.deny,
    name: 'DenyPage',
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        /* webpackMode: "lazy-once" */
        `@/infrastructure/vue/pages/errors/DenyPage.vue`
      ),
  },
  {
    path: PATHS.errors.serverError,
    name: 'ErrorPage',
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        /* webpackMode: "lazy-once" */
        `@/infrastructure/vue/pages/errors/ErrorPage.vue`
      ),
  },

  /* ############################# */
  /*         PRIVATE PAGES         */
  /* ############################# */

  {
    path: PATHS.dashboard.pathBase,
    name: 'DashboardPage',
    meta: {
      private: true,
      middleware: [authenticated, authorized],
    },
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        /* webpackMode: "lazy-once" */
        `@/infrastructure/vue/pages/private/DashboardPage`
      ),
  },

  /* Monitor */
  {
    path: PATHS.monitor.pathBase,
    name: 'MonitorPage',
    meta: {
      private: true,
      middleware: [authenticated, authorized],
    },
    components: {
      default: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/infrastructure/vue/pages/private/monitor`
        ),
    },
    children: [
      {
        path: PATHS.monitor.assignmentMonitor,
        name: 'AssignmentMonitor',
        meta: {
          private: true,
          middleware: [authenticated, authorized],
        },
        components: {
          default: () =>
            import(
              /* webpackChunkName: "routes" */
              /* webpackMode: "lazy-once" */
              `@/infrastructure/vue/pages/private/monitor/AssignmentMonitor`
            ),
        },
      },
      {
        path: PATHS.monitor.attentionMonitor,
        name: 'AttentionMonitor',
        meta: {
          private: true,
          middleware: [authenticated, authorized],
        },
        components: {
          default: () =>
            import(
              /* webpackChunkName: "routes" */
              /* webpackMode: "lazy-once" */
              `@/infrastructure/vue/pages/private/monitor/AttentionMonitor`
            ),
        },
      },
    ],
  },

  /* ############################# */
  /*         PUBLIC PAGES          */
  /* ############################# */

  {
    path: PATHS.login.pathBase,
    name: 'LoginPage',
    meta: {
      middleware: redirectHome,
    },
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        /* webpackMode: "lazy-once" */
        `@/infrastructure/vue/pages/public/LoginPage`
      ),
  },
];
